import { render } from "./AuthBox.vue?vue&type=template&id=203c5f32&scoped=true"
import script from "./AuthBox.vue?vue&type=script&lang=js"
export * from "./AuthBox.vue?vue&type=script&lang=js"

import "./AuthBox.vue?vue&type=style&index=0&id=203c5f32&scoped=true&lang=css"
import "./AuthBox.vue?vue&type=style&index=1&id=203c5f32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-203c5f32"]])

export default __exports__